import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { ThemeContext } from '../../../../components/ThemeContext'

const OrgListsPage: React.FC = () => {
    const navigate = useNavigate()
    const { theme } = useContext(ThemeContext)

    return (
        <div className="flex flex-col text-[#181818] dark:text-[#FFFFFF] h-full">
            <div className="bg-[#e5e5e5] dark:bg-[#111111]">
                <div className="w-auto h-20 mx-6 flex flex-row gap-x-5 ">
                    <div className="w-full h-20 my-auto content-center ">
                        <p className="text-sm text-[#181818] dark:text-[#FFFFFF]">
                            Реестр перечней
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-1 justify-center max-h-[calc(100vh_-_80px)] p-5 bg-[#f0f3f5] dark:bg-[#181818]">
                <div className="flex flex-col h-full w-[1260px] space-y-10">
                    {/* // body */}
                    <div className="flex h-[calc(100vh_-_120px)] bg-[#f0f3f5] dark:bg-[#181818]">
                        {/* table */}
                        <div className="flex flex-col h-full w-full">
                            {/* toolbar */}
                            <div className="flex flex-row gap-1 p-2 rounded-t-lg items-center h-10 text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]">
                                <div className="w-6 h-6"></div>
                            </div>

                            {/* name */}
                            <div className="flex flex-row gap-1 text-[10px] px-1 py-2 h-10 text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#e4e7ea] dark:bg-[#262427]">
                                <div className="flex w-10 items-center justify-center text-center">
                                    №
                                </div>
                                <div className="flex flex-1 items-center justify-center text-center">
                                    Наименование перечня
                                </div>
                                <div className="flex w-28 items-center justify-center text-center">
                                    Количество позиций
                                </div>
                                <div className="flex w-28 items-center justify-center text-center">
                                    Дата изменения
                                </div>
                            </div>

                            {/* data */}
                            <div className="flex flex-col gap-1 py-1 h-dvh overflow-y-auto bg-[#e4e6e8] dark:bg-[#1D1C1E] custom-scrollbar">
                                {/* Вывод пользователей */}
                                <>
                                    <div
                                        className="flex flex-row cursor-pointer gap-1 mx-1 text-[11px] rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                        onClick={() =>
                                            navigate('/hub/org/lists/msp')
                                        }
                                    >
                                        <div className="flex w-10 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            1
                                        </div>
                                        <div className="flex flex-1 items-center justify-left text-left px-2 py-2">
                                            Перечень товаров, работ, услуг,
                                            закупки которых осуществляются у
                                            субъектов малого и среднего
                                            предпринимательства
                                        </div>
                                        <div className="flex w-28 items-center justify-center px-2">
                                            -
                                        </div>
                                        <div className="flex w-28 items-center justify-center px-2">
                                            -
                                        </div>
                                    </div>

                                    <div
                                        className="flex flex-row cursor-pointer gap-1 mx-1 text-[11px] rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                        onClick={() =>
                                            navigate('/hub/org/lists/ep')
                                        }
                                    >
                                        <div className="flex w-10 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            2
                                        </div>
                                        <div className="flex flex-1 items-center justify-left text-left px-2 py-2">
                                            Перечень оснований закупки у
                                            единственного поставщика
                                            (исполнителя, подрядчика)
                                        </div>
                                        <div className="flex w-28 items-center justify-center px-2">
                                            -
                                        </div>
                                        <div className="flex w-28 items-center justify-center px-2">
                                            -
                                        </div>
                                    </div>

                                    <div
                                        className="flex flex-row cursor-pointer gap-1 mx-1 text-[11px] rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                        onClick={() =>
                                            navigate('/hub/org/lists/fxd')
                                        }
                                    >
                                        <div className="flex w-10 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            3
                                        </div>
                                        <div className="flex flex-1 items-center justify-left text-left px-2 py-2">
                                            Перечень кодов и статей расходов
                                        </div>
                                        <div className="flex w-28 items-center justify-center px-2">
                                            -
                                        </div>
                                        <div className="flex w-28 items-center justify-center px-2">
                                            -
                                        </div>
                                    </div>
                                </>
                            </div>

                            {/* buttons */}
                            <div className="flex flex-row gap-1 p-2 rounded-b-lg h-10 space-x-2 text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrgListsPage
